<template>
  <BaseModal name="modalVideoSupport" width="1280" :clickToClose="false" :shiftY="0.5" :adaptive="true"
    @before-open="(params) => beforeOpen(params)" @before-close="() => (videoID = '')" height="auto"
    classes="bg-transparent shadow-none">
    <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100 overflow-hidden">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn-close" @click="
          () => {
            $modal.hide('modalVideoSupport')
          }
        "></button>
      </div>

      <div class="" style="position: relative;
      padding-bottom: 56.25%; 
      height: 0;
      overflow: hidden;">
        <BaseLoader v-if="localLoading"></BaseLoader>
        <vue-rutube ref="player" width="1220" height="686" style="position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;" :videoId="videoID" v-if="videoID" />
      </div>
    </div>
  </BaseModal>
</template>

<script>
import VueRutube from 'vue-rutube'
import GeneralService from '@/api/GeneralService'

export default {
  components: {
    VueRutube
  },
  data() {
    return {
      videoID: '',
      localLoading: false
    }
  },

  methods: {
    beforeOpen({ params }) {
      console.log(params);
      if (params?.videoID) {
        this.videoID = params?.videoID.split('/')[4]
      } else {
        this.localLoading = true
        GeneralService.get(`/academy/video/${params?.id}`)
          .then((data) => {
            if (data.data.data) {
              this.videoID = data.data.data.split('/')[4]
            }

          })
          .catch((e) => {
            this.$toast.error('Неизвестная ошибка при получении ссылки на видео', { duration: 5000 })
            this.$modal.hide('modalVideoSupport')
          }).then(() => {
            this.localLoading = false
          })
      }
    }
  },
  computed: {
    // player() {
    //   return this.$refs.player
    // },
  }
}
</script>
